export const SECTION_BACKGROUNDS = [
  { id: "hero", fr: "Haut de page (hero)", en: "Top (hero)", def: "#0A1428" },
  { id: "marquee", fr: "Bandeau défilant", en: "Scrolling ribbon", def: "#12254D" },
  { id: "cabinet", fr: "Le Cabinet", en: "The Firm", def: "#0A1428" },
  { id: "expertises", fr: "Expertises", en: "Expertise", def: "#101E3D" },
  { id: "methode", fr: "Méthodologie", en: "Methodology", def: "#0A1428" },
  { id: "video", fr: "Vidéo", en: "Video", def: "#101E3D" },
  { id: "clients", fr: "Clients", en: "Clients", def: "#0A1428" },
  { id: "realisations", fr: "Réalisations", en: "Our work", def: "#101E3D" },
  { id: "valeurs", fr: "Valeurs", en: "Values", def: "#0A1428" },
  { id: "temoignages", fr: "Témoignages", en: "Testimonials", def: "#101E3D" },
  { id: "contact", fr: "Contact", en: "Contact", def: "#101E3D" },
  { id: "footer", fr: "Pied de page", en: "Footer", def: "#101E3D" },
  { id: "legal", fr: "Mentions légales", en: "Legal page", def: "#0A1428" },
  { id: "actualites", fr: "Page Actualités", en: "News page", def: "#0A1428" },
];

export const FONT_OPTIONS = [
  { id: "cormorant", fr: "Cormorant — élégant", en: "Cormorant — elegant", value: "'Cormorant Garamond', serif" },
  { id: "outfit", fr: "Outfit — moderne", en: "Outfit — modern", value: "'Outfit', sans-serif" },
  { id: "playfair", fr: "Playfair — éditorial", en: "Playfair — editorial", value: "'Playfair Display', serif" },
  { id: "dm", fr: "DM Sans — épuré", en: "DM Sans — clean", value: "'DM Sans', sans-serif" },
  { id: "grotesk", fr: "Space Grotesk — tech", en: "Space Grotesk — tech", value: "'Space Grotesk', sans-serif" },
  { id: "merri", fr: "Merriweather — classique", en: "Merriweather — classic", value: "'Merriweather', serif" },
  { id: "poppins", fr: "Poppins — rond", en: "Poppins — rounded", value: "'Poppins', sans-serif" },
];

export const SCALE_OPTIONS = [
  { id: "0.9", fr: "Petite", en: "Small" },
  { id: "1", fr: "Normale", en: "Normal" },
  { id: "1.1", fr: "Grande", en: "Large" },
  { id: "1.2", fr: "Très grande", en: "Extra large" },
];

export const THEME_DEFAULTS = {
  font_scale: "1",
  font_title: "'Cormorant Garamond', serif",
  font_body: "'Outfit', sans-serif",
  text_color: "#FFFFFF",
  accent: "#2B6BFF",
};

export const themeVal = (content, key) =>
  content[`theme_${key}`]?.fr ||
  THEME_DEFAULTS[key] ||
  SECTION_BACKGROUNDS.find((s) => `bg_${s.id}` === key)?.def ||
  "";

const ALT_SECTIONS = ["expertises", "video", "realisations", "temoignages", "contact", "footer"];

const buildSections = (base, alt, ribbon) =>
  Object.fromEntries(
    SECTION_BACKGROUNDS.map((s) => [
      `bg_${s.id}`,
      s.id === "marquee" ? ribbon : ALT_SECTIONS.includes(s.id) ? alt : base,
    ])
  );

export const THEME_PRESETS = [
  {
    id: "nuit",
    fr: "Bleu nuit",
    en: "Night blue",
    swatches: ["#0A1428", "#101E3D", "#2B6BFF"],
    values: {
      ...buildSections("#0A1428", "#101E3D", "#12254D"),
      text_color: "#FFFFFF",
      accent: "#2B6BFF",
      font_scale: "1",
      font_title: "'Cormorant Garamond', serif",
      font_body: "'Outfit', sans-serif",
    },
  },
  {
    id: "sable",
    fr: "Sable chaud",
    en: "Warm sand",
    swatches: ["#FBF7F0", "#F4F1EA", "#E0482B"],
    values: {
      ...buildSections("#FBF7F0", "#F4F1EA", "#FDF6E3"),
      text_color: "#1A202C",
      accent: "#E0482B",
      font_scale: "1",
      font_title: "'Cormorant Garamond', serif",
      font_body: "'Outfit', sans-serif",
    },
  },
  {
    id: "lagon",
    fr: "Vert lagon",
    en: "Lagoon green",
    swatches: ["#06312C", "#0A3E38", "#17B890"],
    values: {
      ...buildSections("#06312C", "#0A3E38", "#0B3A34"),
      text_color: "#F2FBF7",
      accent: "#17B890",
      font_scale: "1",
      font_title: "'Cormorant Garamond', serif",
      font_body: "'Outfit', sans-serif",
    },
  },
  {
    id: "bleurose",
    fr: "Bleu & Rose",
    en: "Blue & Pink",
    swatches: ["#0F1B33", "#182747", "#F472B6"],
    values: {
      ...buildSections("#0F1B33", "#182747", "#1E3054"),
      text_color: "#F5F7FB",
      accent: "#F472B6",
      font_scale: "1",
      font_title: "'Cormorant Garamond', serif",
      font_body: "'Outfit', sans-serif",
    },
  },
  {
    id: "rose",
    fr: "Rose poudré",
    en: "Powder pink",
    swatches: ["#FFF5F7", "#FBE4EC", "#DB2777"],
    values: {
      ...buildSections("#FFF5F7", "#FBE4EC", "#FDEBF2"),
      text_color: "#3D1F2D",
      accent: "#DB2777",
      font_scale: "1",
      font_title: "'Cormorant Garamond', serif",
      font_body: "'Outfit', sans-serif",
    },
  },
  {
    id: "mauve",
    fr: "Mauve profond",
    en: "Deep mauve",
    swatches: ["#1D1530", "#2A1D44", "#C084FC"],
    values: {
      ...buildSections("#1D1530", "#2A1D44", "#332352"),
      text_color: "#F3EEF9",
      accent: "#C084FC",
      font_scale: "1",
      font_title: "'Cormorant Garamond', serif",
      font_body: "'Outfit', sans-serif",
    },
  },
  {
    id: "jaune",
    fr: "Jaune soleil",
    en: "Sunny yellow",
    swatches: ["#FFFBEB", "#FEF3C7", "#D97706"],
    values: {
      ...buildSections("#FFFBEB", "#FEF3C7", "#FDF6DC"),
      text_color: "#3A2E10",
      accent: "#D97706",
      font_scale: "1",
      font_title: "'Cormorant Garamond', serif",
      font_body: "'Outfit', sans-serif",
    },
  },
  {
    id: "gris",
    fr: "Gris élégant",
    en: "Elegant grey",
    swatches: ["#F4F5F7", "#E5E7EB", "#374151"],
    values: {
      ...buildSections("#F4F5F7", "#E5E7EB", "#EDEFF3"),
      text_color: "#1F2937",
      accent: "#374151",
      font_scale: "1",
      font_title: "'Cormorant Garamond', serif",
      font_body: "'Outfit', sans-serif",
    },
  },
];
